import React from 'react';

export default function Button({ Class, Name, Title, BtnIcon, Clickble }) {
  return (
    <button type="button" className={`${Class} ${Title || ''}`} onClick={Clickble}>
      <span className="title">{Name}</span>
      {BtnIcon && <span className={BtnIcon}><i /></span>}
    </button>
  );
}
